<template>
<about-us-section :section="section" :section-class="sectionClass">
  <template slot="content">
    <div v-for="card in section.list" class="about-us-section-content-card" :class="cardClasses(card)">
      <div class="about-us-section-content-card-image">
        <img :src="card.image" alt="">
      </div>
      <div v-if="shouldDisplayBody(card)" class="about-us-section-content-card-body">
        <h3 v-if="card.title" class="about-us-section-content-card-heading">{{ card.title }}</h3>
        <p v-if="card.content" class="about-us-section-content-card-text">
          {{ card.content }}
        </p>
      </div>
    </div>
  </template>
</about-us-section>
</template>

<script>
import Vue from 'vue'
import AboutUsSection from './AboutUsSection'
import HasSectionHighlights from '@/mixins/HasSectionHighlights'

export default Vue.extend({
  props: ['section', 'namespace'],

  mixins: [HasSectionHighlights],

  components: {
    AboutUsSection,
  },

  computed: {
    sectionClass() {
      return `about-us-cards-section${this.sectionHighlightClasses}`
    },
  },

  methods: {
    cardClasses(card) {
      if (card.image && !card.title && !card.content) {
        return 'about-us-section-content-card-image-only'
      }

      return ''
    },

    shouldDisplayBody(card) {
      return card.title || card.content
    },

    getSectionNamespace() {
      return this.namespace
    },
  },
})
</script>
